// @ts-nocheck
import React, {useEffect, useState} from 'react';
import {
  AbroadPackageClientState,
  AbroadPackageModel,
  IsBankOrByUse,
  PackageType,
  RootState,
  SupportedSocialMediaApplications,
  UnitMeasureCodeOptionsFeature,
} from '../Models/AbroadPackageModels';
import AbroadDifferentTarifTab from './AbroadDifferentTarifTab';
import Config from '../../../../../Config';
import '../Sass/AbroadPackageTab.scss';
import {getImageSrc} from 'app/utilities/ImageProps';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import {gaEvent} from '../../../../../utilities/analytics/tracking.js';
import constants from '../../../../../utilities/analytics/constants.js';
import {useDispatch, useSelector} from 'react-redux';
import {customerTypeEnum} from '../../cellcomAbroadVariables.js';
import familyIcon from '../Icons/family_icon';
import {popupReasonEnum} from '../../cellcomAbroadVariables.js';
import {openModal, getAbroadFamilyPackageInfo} from '../../cellcomAbroadBlockSlice.js';
import Image from 'app/Components/Shared/Image/image';
import {getDataUsageDisplay} from '../../cellcomAbroadUtilities';
interface AbroadPackageTabProps {
  context?: IEpiserverContext;
  packageData: AbroadPackageModel;
  supportedApps?: SupportedSocialMediaApplications[];
  isInTicket?: boolean;
  businessOrPrivate?: string;
  comingFromPackageManager?: boolean;
  businessSocPackageFolderId: string;
  privateSocPackageFolderId: string;
}

const AbroadPackageTab = ({
  packageData,
  supportedApps,
  context,
  isInTicket,
  businessOrPrivate,
  businessSocPackageFolderId,
  privateSocPackageFolderId,
  comingFromPackageManager,
}: AbroadPackageTabProps) => {
  const [displayPriceAllState, setDisplayPriceAllState] = useState(false);
  const dispatch = useDispatch();
  const cellcomAbroad = useSelector<RootState>((state) => state.cellcomAbroad) as AbroadPackageClientState;

  useEffect(() => {
    if (packageData?.packageDetailsList?.length > 1 && isInTicket) {
      let category: any, eventType: any, eventParams: any;
      if (businessOrPrivate !== customerTypeEnum.BUSINESS) {
        if (!cellcomAbroad.startedFromPackage) {
          category = constants.ABROAD_TICKET_PACKAGE_BY_USE_PRICES_DATA_IS_OPENED_PRIVATE.category;
          eventType = constants.ABROAD_TICKET_PACKAGE_BY_USE_PRICES_DATA_IS_OPENED_PRIVATE.eventType;
          eventParams = constants.ABROAD_TICKET_PACKAGE_BY_USE_PRICES_DATA_IS_OPENED_PRIVATE.eventParams;
        } else {
          category = constants.ABROAD_TICKET_PACKAGE_BY_USE_PRICES_DATA_IS_OPENED_PRIVATE_FROM_PACKAGE.category;
          eventType = constants.ABROAD_TICKET_PACKAGE_BY_USE_PRICES_DATA_IS_OPENED_PRIVATE_FROM_PACKAGE.eventType;
          eventParams = constants.ABROAD_TICKET_PACKAGE_BY_USE_PRICES_DATA_IS_OPENED_PRIVATE_FROM_PACKAGE.eventParams;
        }
        gaEvent(category, eventType, eventParams);
      }
    }
  }, [packageData?.packageDetailsList?.length]);

  const handleClickPlusDisplayPriceAllState = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!displayPriceAllState) {
      let category: any, eventType: any, eventParams: any;
      if (businessOrPrivate !== customerTypeEnum.BUSINESS) {
        if (!cellcomAbroad.startedFromPackage) {
          category = constants.ABROAD_TICKET_PACKAGE_BY_USE_SHOW_PRICES_BUTTON_CLICK_PRIVATE.category;
          eventType = constants.ABROAD_TICKET_PACKAGE_BY_USE_SHOW_PRICES_BUTTON_CLICK_PRIVATE.eventType;
          eventParams = constants.ABROAD_TICKET_PACKAGE_BY_USE_SHOW_PRICES_BUTTON_CLICK_PRIVATE.eventParams;
        } else {
          category = constants.ABROAD_TICKET_PACKAGE_BY_USE_SHOW_PRICES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.category;
          eventType = constants.ABROAD_TICKET_PACKAGE_BY_USE_SHOW_PRICES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.eventType;
          eventParams = constants.ABROAD_TICKET_PACKAGE_BY_USE_SHOW_PRICES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE.eventParams;
        }
        gaEvent(category, eventType, eventParams);
      }
    }

    setDisplayPriceAllState(!displayPriceAllState);
  };

  const centerStateByUse = () => {
    if (packageData?.packageDetailsList?.length === 1) {
      return (
        <div className={`abroad-package-tab--byUse__centerState--oneGroupState`}>
          <div className='abroad-package-tab--byUse__centerState--oneGroupState__title'>{packageData?.titleEpi}</div>
          {stateRightFormatByUse()}
        </div>
      );
    }
    return (
      <div className='abroad-package-tab--byUse__centerState--manyGroupState'>
        <div className='abroad-package-tab--byUse__centerState--manyGroupState__title'>{packageData?.titleEpi}</div>
        <div className='abroad-package-tab--byUse__centerState--manyGroupState__content'>
          <div className='abroad-package-tab--byUse__centerState--manyGroupState__content__up'>
            שימו לב, במסלול זה תעריף שונה במדינות שונות
          </div>
          <div
            className='abroad-package-tab--byUse__centerState--manyGroupState__content__down'
            onClick={handleClickPlusDisplayPriceAllState}>
            <span>לתעריף כל המדינות</span>
            <span>{`+`}</span>
          </div>
          {displayPriceAllState ? (
            <AbroadDifferentTarifTab packageDetailsList={packageData.packageDetailsList} packageData={packageData} />
          ) : null}
        </div>
      </div>
    );
  };

  const stateRightFormatByUse = () => {
    let stateCommat = packageData?.packageDetailsList[0].countrySupportedList?.map((x, i) => {
      if (i === 0) return `ב${x.countryHebName}`;
      else return x.countryHebName;
    });
    if (stateCommat?.length < 6)
      return <div className='abroad-package-tab--byUse__centerState--oneGroupState__content'>{stateCommat?.join(', ')}</div>;
    else return <></>;
  };

  const detailsRenderingByUse = () => {
    return <div className='abroad-package-tab--byUse__details'>{filterRenderingByUse()}</div>;
  };

  const filterRenderingByUse = () => {
    switch (packageData.type) {
      case PackageType.VoiceSmsData: {
        return (
          <>
            <div className='abroad-package-tab--byUse__details--voice-sms'>
              {voiceRenderingByUse()}
              <div className='abroad-package-tab--byUse__details--voice-sms__separator'></div>
              {smsRenderingByUse()}
            </div>
            {dataRenderingByUse()}
          </>
        );
      }
      case PackageType.VoiceAndSmsData: {
        return (
          <>
            <div className='abroad-package-tab--byUse__details--voice-sms'>{voiceAndSmsRenderingByUse()}</div>
            {dataRenderingByUse()}
          </>
        );
      }
      case PackageType.VoiceAndSms: {
        return <div className='abroad-package-tab--byUse__details--voice-sms'>{voiceAndSmsRenderingByUse()}</div>;
      }
      case PackageType.VoiceSms: {
        return (
          <div className='abroad-package-tab--byUse__details--voice-sms'>
            {voiceRenderingByUse()}
            <div className='abroad-package-tab--byUse__details--voice-sms__separator'></div>
            {smsRenderingByUse()}
          </div>
        );
      }
      case PackageType.Data: {
        return <>{dataRenderingByUse()}</>;
      }
      default:
        return null;
    }
  };

  const dataRenderingByUse = () => {
    const details = packageData?.packageDetailsList[0];
    const dataDisplay = getDataUsageDisplay(details?.data);
    return (
      <div className='abroad-package-tab--byUse__details__data'>
        <span>{dataDisplay.value}</span>
        <span>{dataDisplay.unit}</span> ב-{shekelOrAgourot(details.data.priceByUsage)}
        {!(
          packageData?.steppedPerDay === true && packageData?.type.toLowerCase() === "data") && (
              <>
                ב - {shekelOrAgourot(details.data.priceByUsage)}
                {details.data.unit === UnitMeasureCodeOptionsFeature.PerDay ? ' ליום' : ''}
              </>
            )}
      </div>
    );
  };

  const smsRenderingByUse = () => {
    const details = packageData?.packageDetailsList[0];
    return <div className='abroad-package-tab--byUse__details__sms'>{shekelOrAgourot(details.sms.priceByUsage)} להודעה</div>;
  };

  const voiceRenderingByUse = () => {
    const details = packageData?.packageDetailsList[0];
    return <div className='abroad-package-tab--byUse__details__voice'>{shekelOrAgourot(details.voice.priceByUsage)} לדקה</div>;
  };

  const voiceAndSmsRenderingByUse = () => {
    const details = packageData?.packageDetailsList[0];
    return <div className='abroad-package-tab--byUse__details__voiceAndSms'>{shekelOrAgourot(details.voice.priceByUsage)} לדקה/הודעה</div>;
  };

  const shekelOrAgourot = (price: number) => {
    if (price >= 1)
      return (
        <>
          <span>{price}</span> ₪
        </>
      );
    else
      return (
        <>
          <span>{price * 100}</span> אג`
        </>
      );
  };

  const titlePackageBank = () => {
    return <div className='abroad-package-tab--bank__title'>{packageData?.titleEpi}</div>;
  };

  const detailsRenderingBank = () => {
    return <div className='abroad-package-tab--bank__all-details'>{filterRenderingBank()}</div>;
  };

  const filterRenderingBank = () => {
    switch (packageData.type) {
      case PackageType.VoiceSmsData: {
        return voiceAndSmsDataTypeRenderingBank();
      }
      case PackageType.VoiceAndSmsData: {
        return voiceAndSmsDataTypeRenderingBank();
      }
      case PackageType.VoiceAndSms: {
        return voiceAndSmsTypeRenderingBank();
      }
      case PackageType.VoiceSms: {
        return voiceAndSmsTypeRenderingBank();
      }
      case PackageType.Data: {
        return dataTypeRenderingBank();
      }
      default:
        return null;
    }
  };

  const voiceAndSmsDataTypeRenderingBank = () => {
    return (
      <>
        <div className='abroad-package-tab--bank__all-details__sms-voice'>
          <span className='abroad-package-tab--bank__all-details__data'>
            {packageData?.packageDetailsList[0]?.data?.value}
            {packageData.packageDetailsList[0]?.data?.unit} גלישה
          </span>
          <span className='abroad-package-tab--bank__all-details__sms-voice__separator'>|</span>
          {detailsPhoneSmsRenderingBank()}
        </div>
        {packageData.dataForApp?.hasDataForApp ? dataUnlimitedAppTextBank() : null}
        {packageData.dataForApp?.hasDataForApp ? dataUnlimitedAppIconBank() : null}
      </>
    );
  };
  const voiceAndSmsTypeRenderingBank = () => {
    return <div className='abroad-package-tab--bank__all-details__sms-voice'>{detailsPhoneSmsRenderingBank()}</div>;
  };

  const dataTypeRenderingBank = () => {
    return (
      <>
        {dataRenderingBank()}
        {packageData.dataForApp?.hasDataForApp ? dataUnlimitedAppIconBank() : null}
      </>
    );
  };

  const dataRenderingBank = () => {
    if (packageData.packageDetailsList[0].data.isUnlimited)
      return <div className={`abroad-package-tab--bank__all-details__data`}>גלישה ללא הגבלה</div>;
    else
      return (
        <div className={`abroad-package-tab--bank__all-details__data--unlimited`}>
          <div className={`abroad-package-tab--bank__all-details__data`} style={{fontWeight: 'normal'}}>
            {packageData?.packageDetailsList[0]?.data?.value}
            {packageData.packageDetailsList[0]?.data?.unit} גלישה
          </div>
          {packageData.dataForApp?.hasDataForApp ? dataUnlimitedAppTextBank() : null}
        </div>
      );
  };

  const renderIconBank = () => {
    let iconTagArray: JSX.Element[] = [];
    for (let i = 0; i < supportedApps?.length; i++) {
      let src = getImageSrc(supportedApps[i]?.appDarkIcon, context);
      iconTagArray.push(
        <Image
          key={supportedApps[i].appName}
          src={src}
          alt={supportedApps[i].appName}
          className='abroad-package-client__data--bank-unlimited-app--icons--item'
        />,
      );
    }

    return iconTagArray;
  };
  const dataUnlimitedAppTextBank = () => {
    return (
      <>
        <div className='abroad-package-tab--bank__all-details__unlimited__text'>
          {packageData?.dataForApp?.isUnlimitedDataForApp
            ? `גלישה חינם לאפליקציות נבחרות`
            : `וגם ${packageData?.dataForApp?.valueDataForApp}${packageData?.dataForApp.unit} גלישה לאפליקציות נבחרות`}
        </div>
      </>
    );
  };

  const dataUnlimitedAppIconBank = () => {
    return (
      <>
        <div className='abroad-package-tab--bank__all-details__unlimited__app'>{renderIconBank()}</div>
      </>
    );
  };

  const detailsPhoneSmsRenderingBank = () => {
    switch (packageData.type) {
      case PackageType.VoiceSmsData: {
        if (packageData?.packageDetailsList[0].voice.isUnlimited && packageData.packageDetailsList[0].sms.isUnlimited)
          return <>{voiceSmsUnlimitedRenderingBank()}</>;
        else
          return (
            <>
              <span className={`abroad-package-tab--bank__all-details__sms-voice__item`}>{voiceRenderingBank()}</span>
              <span className={`abroad-package-tab--bank__all-details__sms-voice__separator`}>|</span>
              <span className={`abroad-package-tab--bank__all-details__sms-voice__item`}>{smsRenderingBank()}</span>
            </>
          );
      }
      case PackageType.VoiceAndSmsData: {
        if (packageData?.packageDetailsList[0].voice.isUnlimited && packageData.packageDetailsList[0].sms.isUnlimited)
          return <>{voiceSmsUnlimitedRenderingBank()}</>;
        else return <>{voiceAndSmsRenderingBank()}</>;
      }
      case PackageType.VoiceSms: {
        if (packageData?.packageDetailsList[0].voice.isUnlimited && packageData.packageDetailsList[0].sms.isUnlimited)
          return <>{voiceSmsUnlimitedRenderingBank()}</>;
        else
          return (
            <>
              <span className={`abroad-package-tab--bank__all-details__sms-voice__item`}>{voiceRenderingBank()}</span>
              <span className={`abroad-package-tab--bank__all-details__sms-voice__separator`}>|</span>
              <span className={`abroad-package-tab--bank__all-details__sms-voice__item`}>{smsRenderingBank()}</span>
            </>
          );
      }

      case PackageType.VoiceAndSms: {
        if (packageData?.packageDetailsList[0].voice.isUnlimited && packageData.packageDetailsList[0].sms.isUnlimited)
          return <>{voiceSmsUnlimitedRenderingBank()}</>;
        else return <>{voiceAndSmsRenderingBank()}</>;
      }

      default: {
        return null;
      }
    }
  };

  const voiceSmsUnlimitedRenderingBank = () => {
    return <>שיחות והודעות ללא הגבלה</>;
  };

  const voiceAndSmsRenderingBank = () => {
    return <>{packageData?.packageDetailsList[0].voice.value} דקות והודעות</>;
  };
  const voiceRenderingBank = () => {
    return <>{packageData?.packageDetailsList[0].voice.value} דקות</>;
  };

  const smsRenderingBank = () => {
    return <>{packageData?.packageDetailsList[0].sms.value} הודעות</>;
  };

  const infoFamilyPackage = () => {
    async function getFamilyPackagePopupData() {
      const blockId = businessOrPrivate !== customerTypeEnum.BUSINESS ? privateSocPackageFolderId : businessSocPackageFolderId;
      const socCode = packageData.socCodeFamilyBonus;
      await dispatch(getAbroadFamilyPackageInfo({blockId, socCode})).then((res) => {
        dispatch(openModal(popupReasonEnum.DISPLAY_INFO_FAMILY));
      });
    }
    if (packageData?.isFamilyBonus)
      return (
        <div className='abroad-package-tab__family-package-info'>
          <div className='abroad-package-tab__family-package-info__icon'>{familyIcon()}</div>
          <div className='abroad-package-tab__family-package-info__text'>
            אפשר להתקין את החבילה על מנוי שנמצא תחת אותם ת.ז. ואמצעי תשלום של החבילה הראשית
          </div>
        </div>
      );
    if (packageData?.isGiveFamilyBonus)
      return (
        <div className='abroad-package-tab__family-package-info'>
          <div className='abroad-package-tab__family-package-info__icon'>{familyIcon()}</div>
          <div className='abroad-package-tab__family-package-info__text'>
            אחרי התקנת חבילה זו תוכלו להתקין את חבילת בני משפחה{' '}
            <span className='abroad-package-tab__family-package-info__text--pink' onClick={() => getFamilyPackagePopupData()}>
              למי מגיעה ההטבה המשפחתית ומה היא כוללת?
            </span>
          </div>
        </div>
      );
  };

  return (
    <div className='abroad-package-tab'>
      {packageData?.isBankOrByUse === IsBankOrByUse.ByUse ? (
        <div className='abroad-package-tab--byUse__container'>
          {centerStateByUse()}
          {packageData?.packageDetailsList?.length === 1 ? detailsRenderingByUse() : null}
        </div>
      ) : null}

      {packageData?.isBankOrByUse === IsBankOrByUse.Bank ? (
        <div className='abroad-package-tab--bank__container'>
          {titlePackageBank()}
          {detailsRenderingBank()}
        </div>
      ) : null}
      {isInTicket && infoFamilyPackage()}
    </div>
  );
};

export default AbroadPackageTab;
